// Inner routes
import { requireUser } from '~/apps/shared/permissions';
import { appRoutes as adminRoutes } from './admin/routes';
import { appRoutes as mobileAppRoutes } from './mobile/routes';

// Client-side routes
export const appRoutes = [
  {
    name: 'receiver',
    path: '/receiver',
    forwardTo: 'receiver.admin.transactions',
    canActivate: requireUser(),
    children: adminRoutes.concat(mobileAppRoutes),
  }
];
